/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerRightDownDouble = createReactComponent(
  "corner-right-down-double",
  "IconCornerRightDownDouble",
  [
    ["path", { d: "M5 4h6a3 3 0 0 1 3 3v7", key: "svg-0" }],
    ["path", { d: "M10 10l4 4l4 -4m-8 5l4 4l4 -4", key: "svg-1" }]
  ]
);

export { IconCornerRightDownDouble as default };
//# sourceMappingURL=IconCornerRightDownDouble.js.map
